/*
 * @Author: zhangxiaoda zhangxiaoda@nextmar.com
 * @Date: 2025-05-07 15:41:42
 * @LastEditors: zhangxiaoda zhangxiaoda@nextmar.com
 * @LastEditTime: 2025-05-07 15:45:59
 * @FilePath: /zeelool-nextjs/src/api/home.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest } from '@/utils/axios';
import { getStableClientCyyInfo } from '@/utils/currency/client-currency';

export const getHomePageData = (data: { block_type: number; status: number }) =>
  httpRequest('POST:/api/block/block', { data: { ...data, ...getStableClientCyyInfo() } });

// 领取多个优惠券
export const getBlockCoupons = (data: { coupon_ids: string[] }) =>
  httpRequest('POST:/api/customer/get_block_coupons', { data });
